import {IAppState} from 'Common/store/IAppState';
import {ICommunication} from 'Common/store/utils/communication';

export function selectIsLoadingFormData(state: IAppState, otherCommunications: ICommunication[]) {
  return [...otherCommunications].some(comm => comm.isRequesting);
}
